import axios from '../lib/axios';

export const getManagerDashboard = () =>
    axios.get('/api/manager/dashboard').then(r => r.data);

export const getAssignmentRules = () =>
    axios.get('/api/manager/assignment-rules').then(r => r.data);

export const saveAssignmentRule = (data) =>
    axios.post('/api/manager/assignment-rules', data).then(r => r.data);

export const updateAssignmentRule = ({ id, ...data }) =>
    axios.put(`/api/manager/assignment-rules/${id}`, data).then(r => r.data);

export const deleteAssignmentRule = (id) =>
    axios.delete(`/api/manager/assignment-rules/${id}`).then(r => r.data);

export const getMyPortfolio = () =>
    axios.get('/api/contacts/my-portfolio').then(r => r.data);

export const bulkReassign = (data) =>
    axios.post('/api/contacts/bulk-reassign', data).then(r => r.data);

export const getOwnershipHistory = (contactId) =>
    axios.get(`/api/contacts/${contactId}/ownership-history`).then(r => r.data);
